<template>
  <section class="content">
    <div class="row center-block">
      <div class="box">
        <!-- Box Header -->
        <div class="box-header">
          <div class="alert alert-dismissible" :class="alert_style" v-if="alert_message != ''">
            <button type="button" class="close" @click="close_alert_message">&times;</button>
            <h4><i class="icon fa fa-check"></i> {{ alert_header }} </h4>
            {{ alert_message }}            
          </div>
        </div>

        <!-- Popup content -->
        <div class="box-body">
          <!-- Campaign name -->
          <div  class="form-group col-xs-12"
                v-bind:class="{ 'has-error': $v.campaignPayout.campaignName.$error }">
            <label>Name of campaign</label>
            <input  type="text"
                    class="form-control"
                    placeholder="Enter campaign name for payout"
                    v-model="campaignPayout.campaignName"
                    @input="$v.campaignPayout.campaignName.$touch()">
            <span class="help-block" v-if="!$v.campaignPayout.campaignName.required && $v.campaignPayout.campaignName.$error">Campaign name is required</span>
          </div>

          <!-- Instagram post url -->
          <div  class="form-group col-xs-12"
                v-bind:class="{ 'has-error': $v.campaignPayout.instagram_post_url.$error }">
            <label>Please submit the URL to your Instagram posting here</label>
            <input  type="text"
                    class="form-control"
                    placeholder="Enter instagram post url for payout"
                    v-model="campaignPayout.instagram_post_url"
                    @input="$v.campaignPayout.instagram_post_url.$touch()">
            <span class="help-block" v-if="!$v.campaignPayout.instagram_post_url.required && $v.campaignPayout.instagram_post_url.$error">Instagram post url is required</span>
          </div>

          <!-- Other social media platform url -->
          <div class="form-group col-xs-12">
            <label>Please submit the URL to your other Social Media posting here</label>
            <input  type="text"
                    class="form-control"
                    placeholder="Enter other social media post url for payout"
                    v-model="campaignPayout.other_social_media_post_url">
          </div>

          <!-- Satisfaction level to campaign -->
          <div class="form-group col-xs-12">
            <label>Please provide your satisfaction level with this campaign</label>
            <select class="form-control"
                    v-model="campaignPayout.satisfaction_level">
              <option v-for="rating in ratingLevels" :key="rating.value" :value="rating.value">{{rating.level}}</option>
            </select>
          </div>

          <!-- Satisfaction level to advertiser -->
          <div class="form-group col-xs-12">
            <label>Please rate your experience with the advertiser's product/services.</label>
            <select class="form-control"
                    v-model="campaignPayout.advertiser_satisfaction_level">
              <option v-for="rating in ratingLevels" :key="rating.value" :value="rating.value">{{rating.level}}</option>
            </select>
          </div>

          <!-- Feedback -->
          <div class="form-group col-xs-12">
            <label>We are dedicated to make the world a better place for our Kobeers. Do provide us with your opinions on how we could improve! (Don't hold back - we're able to handle any opinions!)</label>
            <input  type="text"
                    class="form-control"
                    placeholder="Enter feedback here"
                    v-model="campaignPayout.feedback">
          </div>

          <!-- Subscription -->
          <div class="form-group col-xs-12">
            <label>KOBE is exploring a new option where a portion of your payout will be contributed to a greater cause. <br>
            If you would like to be a part of this movement, kindly select "Yes" below and we will send you an email shortly with more details:
            </label>
            <select class="form-control"
                    v-model="campaignPayout.subscription">
              <option value= 1> Yes </option>
              <option value= 0> No </option>
            </select>
          </div>

          <div class="form-group col-xs-12">
            <button type="button" class="btn btn-primary" @click="createCampaignPayout">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import userAPIs from '../User/userAPIs'
import influencerAPIs from './influencerAPIs'
// import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CreateCampaignPayout',
  data () {
    return {
      user: {},
      alert_message: '',
      alert_header: '',
      alert_style: 'alert-success',
      campaignPayout: {
        campaignName: '',
        instagram_post_url: '',
        other_social_media_post_url: '',
        satisfaction_level: 5,
        advertiser_satisfaction_level: 5,
        feedback: '',
        subscription: 1
      },
      ratingLevels: [
        {
          level: '1',
          value: 1
        },
        {
          level: '2',
          value: 2
        },
        {
          level: '3',
          value: 3
        },
        {
          level: '4',
          value: 4
        },
        {
          level: '5',
          value: 5
        }
      ]
    }
  },
  validations: {
    campaignPayout: {
      campaignName: {
        // required
      },
      instagram_post_url: {
        // required
      }
    }
  },
  computed: {
    currentUserID: function () {
      return this.$store.state.user.id
    }
  },
  methods: {
    close_alert_message: function () {
      this.alert_message = ''
    },
    createCampaignPayout: function () {
      const { campaignPayout } = this

      // Add influencer
      influencerAPIs.createCampaignPayout(this.user.influencerId, campaignPayout)
        .then(response => {
          // Dismiss modal by triggering the click event on Close button
          // this.$refs.closeButton.click()

          // Clear data if successful
          this.clearData()

          // Display popup message
          this.alert_style = 'alert-success'
          this.alert_header = 'Successful submission!'
          this.alert_message = 'We have received your campaign payout submission and will proceed with your payout as soon as possible. Stay tuned!'

          // notify payment Information
          this.$swal({
            title: 'Payment Information',
            html: '<p><b>Kobe</b> shall pay Fees by cheque or bank transfer within forty-five (45) days after the end of each given month.</p> <p>Influencer must provide all applicable personal and bank account information after receiving the live URL link of your posting upon approval of client.</p>',
            type: 'info',
            confirmButtonText: 'OK'
          })

          // Scroll to top
          this.scrollToTop()
        })
        .catch(error => {
          // Display popup message
          this.alert_style = 'alert-error'
          this.alert_header = 'Something went wrong!'
          this.alert_message = 'Please kindly try again or contact us directly'

          // Scroll to top
          this.scrollToTop()

          // Request failed.
          console.log('error', error)
        })
    },
    clearData: function () {
      this.campaignPayout = {
        campaignName: '',
        instagram_post_url: '',
        other_social_media_post_url: '',
        satisfaction_level: 5,
        advertiser_satisfaction_level: 5,
        feedback: '',
        subscription: 1
      }
    },
    scrollToTop: function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.scrollToTop)
        window.scrollTo(0, currentScroll - (currentScroll / 5))
      }
    }
  },
  mounted() {
    // Retrieve user profile
    userAPIs.getUser(this.currentUserID)
      .then(response => {
        // This is for Influencer, we will use the email from Influencer service
        this.user = {
          firstName: response.firstName,
          lastName: response.lastName,
          email: response.influencer.email,
          birthday: response.influencer.birthday,
          gender: response.influencer.gender,
          fullName: response.influencer.fullName,
          bankName: response.influencer.bankName,
          bankAccount: response.influencer.bankAccount,
          mailingAddress: response.influencer.mailingAddress,
          influencerId: response.influencer.id
        }
      })
      .catch(error => {
        // Request failed.
        console.log('error', error)
      })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CreateCampaignPayout.vue?32b9a024